// YouTube / Vimeo links for the Video layout block (build plan §2.3). Same
// patterns as the server's recognizeVideoUrl: http(s)://, optional www. or
// m., then one of
//   youtube.com/watch?v=ID · youtu.be/ID · youtube.com/embed/ID ·
//   youtube.com/shorts/ID (ID = [A-Za-z0-9_-]{6,}),
//   vimeo.com/<digits> · player.vimeo.com/video/<digits>

const HOST = '^https?:\\/\\/(?:www\\.|m\\.)?';
const YT_ID = '([A-Za-z0-9_-]{6,})';
const TAIL = '(?:[?&#/].*)?$';

// Case-insensitive, like the server.
const PATTERNS = [
  ['youtube', `youtube\\.com\\/watch\\?v=${YT_ID}`],
  ['youtube', `youtu\\.be\\/${YT_ID}`],
  ['youtube', `youtube\\.com\\/embed\\/${YT_ID}`],
  ['youtube', `youtube\\.com\\/shorts\\/${YT_ID}`],
  ['vimeo', `vimeo\\.com\\/(\\d+)`],
  ['vimeo', `player\\.vimeo\\.com\\/video\\/(\\d+)`],
].map(([provider, body]) => [
  provider,
  new RegExp(`${HOST}${body}${TAIL}`, 'i'),
]);

// { provider: 'youtube' | 'vimeo', id } or null.
export const recognizeVideoUrl = (url) => {
  if (typeof url !== 'string') return null;
  const text = url.trim();
  if (!text) return null;
  for (let i = 0; i < PATTERNS.length; i += 1) {
    const [provider, rx] = PATTERNS[i];
    const m = rx.exec(text);
    if (m) return { provider, id: m[1] };
  }
  return null;
};

// The iframe src for a recognised link, else null.
export const embedUrl = (url) => {
  const video = recognizeVideoUrl(url);
  if (!video) return null;
  return video.provider === 'youtube'
    ? `https://www.youtube.com/embed/${video.id}`
    : `https://player.vimeo.com/video/${video.id}`;
};
